module.exports = __webpack_public_path__ + "media/images/massage/card-desktop-740366ba3716dacfe337045f88cf6a06.jpg";